


































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { AssetsModule } from '@/store/modules/asset'
import { AppModule } from '@/store/modules/app'
import { RailwayModule } from '@/store/modules/railway'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import ImageEditor from "@/components/products/railway/RailwayImageEditor.vue"
import ImageEditorError from "@/components/common/ImageEditorError.vue"
import { AssetFile } from '@/store/modules/asset'
import { AssetUsage } from '@/utils/assetUsage'

@Component({
    name: 'sticker-edit',
    components: {
        ImageEditor,
        ImageEditorError
    }
})
export default class StickerEdit extends Vue {
    private isDefaultImage:boolean = true

    get devotionText() {
        return RailwayModule.dedication.text
    }

    get devotionTextSize() {
        return RailwayModule.dedication.size + "px";
    }

    get disabledMovement() {
        return ToolbarModule.deactivated & ToolbarDeactivations.ZoomAndRotation
    }

    get disabledToolbar() {
        return ToolbarModule.deactivated && ToolbarDeactivations.ZoomAndRotation && ToolbarDeactivations.Deletion
    }

    get placeholderStyle() {
        return AppModule.currentStepImagePlaceholderStyle
    }

    get selectedAssets() {
        return AssetsModule.selectedAssets
    }

    @Watch('selectedAssets')
    selectedAssetsChanged(newSelectedAssets: AssetFile[]) {
        let asset: AssetFile | undefined = AssetsModule.selected;
        if(asset === undefined) {
            this.isDefaultImage = true
        }else {
            this.isDefaultImage = false
        }
    }
}
